// Landing commercial evolution (sections 38–43): personalization messaging + demo.
export const extra8 = {
  pt: {
    "sales2.personal_title": "Não existe um único jeito de celebrar o Natal.",
    "sales2.personal_text": "Cada família tem sua história, seu orçamento, seus sabores e suas tradições. O MY CHRISTMAS ajuda você a organizar uma celebração que combine com a sua.",
    "sales2.demo_kicker": "Diga como será o seu Natal.",
    "sales2.demo_help": "O MY CHRISTMAS ajuda a organizar.",
    "sales2.say_country": "País", "sales2.say_people": "Pessoas", "sales2.say_budget": "Orçamento", "sales2.say_style": "Estilo",
    "sales2.langs": "Disponível em 5 idiomas",
    "sales2.styles_title": "Um Natal com a sua cara",
    "sales2.tagline_big": "Seu Natal. Do seu jeito.",
    "sales2.tagline_sub": "Conte-nos como será a sua celebração e o MY CHRISTMAS ajuda você a transformar convidados, orçamento e preferências em um plano para o seu Natal.",
  },
  en: {
    "sales2.personal_title": "There is no single way to celebrate Christmas.",
    "sales2.personal_text": "Every family has its story, its budget, its flavors and its traditions. MY CHRISTMAS helps you organize a celebration that matches yours.",
    "sales2.demo_kicker": "Tell us what your Christmas will be like.",
    "sales2.demo_help": "MY CHRISTMAS helps you organize it.",
    "sales2.say_country": "Country", "sales2.say_people": "People", "sales2.say_budget": "Budget", "sales2.say_style": "Style",
    "sales2.langs": "Available in 5 languages",
    "sales2.styles_title": "A Christmas that looks like you",
    "sales2.tagline_big": "Your Christmas. Your way.",
    "sales2.tagline_sub": "Tell us about your celebration and MY CHRISTMAS helps you turn guests, budget and preferences into a plan for your Christmas.",
  },
  es: {
    "sales2.personal_title": "No existe una única forma de celebrar la Navidad.",
    "sales2.personal_text": "Cada familia tiene su historia, su presupuesto, sus sabores y sus tradiciones. MY CHRISTMAS te ayuda a organizar una celebración que combine con la tuya.",
    "sales2.demo_kicker": "Cuéntanos cómo será tu Navidad.",
    "sales2.demo_help": "MY CHRISTMAS te ayuda a organizarla.",
    "sales2.say_country": "País", "sales2.say_people": "Personas", "sales2.say_budget": "Presupuesto", "sales2.say_style": "Estilo",
    "sales2.langs": "Disponible en 5 idiomas",
    "sales2.styles_title": "Una Navidad con tu estilo",
    "sales2.tagline_big": "Tu Navidad. A tu manera.",
    "sales2.tagline_sub": "Cuéntanos sobre tu celebración y MY CHRISTMAS te ayuda a convertir invitados, presupuesto y preferencias en un plan para tu Navidad.",
  },
  fr: {
    "sales2.personal_title": "Il n'existe pas une seule façon de fêter Noël.",
    "sales2.personal_text": "Chaque famille a son histoire, son budget, ses saveurs et ses traditions. MY CHRISTMAS vous aide à organiser une célébration qui vous ressemble.",
    "sales2.demo_kicker": "Dites-nous comment sera votre Noël.",
    "sales2.demo_help": "MY CHRISTMAS vous aide à l'organiser.",
    "sales2.say_country": "Pays", "sales2.say_people": "Personnes", "sales2.say_budget": "Budget", "sales2.say_style": "Style",
    "sales2.langs": "Disponible en 5 langues",
    "sales2.styles_title": "Un Noël qui vous ressemble",
    "sales2.tagline_big": "Votre Noël. À votre façon.",
    "sales2.tagline_sub": "Parlez-nous de votre célébration et MY CHRISTMAS vous aide à transformer invités, budget et préférences en un plan pour votre Noël.",
  },
  it: {
    "sales2.personal_title": "Non esiste un unico modo di festeggiare il Natale.",
    "sales2.personal_text": "Ogni famiglia ha la sua storia, il suo budget, i suoi sapori e le sue tradizioni. MY CHRISTMAS ti aiuta a organizzare una celebrazione che sia la tua.",
    "sales2.demo_kicker": "Raccontaci com'è il tuo Natale.",
    "sales2.demo_help": "MY CHRISTMAS ti aiuta a organizzarlo.",
    "sales2.say_country": "Paese", "sales2.say_people": "Persone", "sales2.say_budget": "Budget", "sales2.say_style": "Stile",
    "sales2.langs": "Disponibile in 5 lingue",
    "sales2.styles_title": "Un Natale che ti somiglia",
    "sales2.tagline_big": "Il tuo Natale. A modo tuo.",
    "sales2.tagline_sub": "Raccontaci la tua celebrazione e MY CHRISTMAS ti aiuta a trasformare ospiti, budget e preferenze in un piano per il tuo Natale.",
  },
};
